export default "__VITE_ASSET__fc699a78__"